export const PAGE_NAME = {
  REPORT_LIST_VIEW: 'Report List View',
  REPORT_STORY_VIEW: 'Report Story View',
  REPORT_VIDEO_VIEW: 'Report Video View',
  CARE_PLAN: 'Care Plan',
  /**
   * Video Events
   */
  VIDEO_COMPONENT_LOADED: 'Video Component Loaded',
  VIDEO_LOAD_STARTED: 'Video Load Started',
  VIDEO_LOADED: 'Video Loaded',
  VIDEO_BUFFERING: 'Video Buffering',
  VIDEO_CAN_PLAY: 'Video Can Play',
  VIDEO_PLAYBACK_START: 'Video Playback Start',
  VIDEO_PLAYBACK_ERROR: 'Video Playback Error',
  VIDEO_STALLED: 'Video Stalled',
  VIDEO_ERRORED: 'Video Errored',
  VIDEO_PLAYING: 'Video Playing',
  VIDEO_LOAD_SUSPENDED: 'Video Load Suspended',
  VIDEO_VIEWED_COMPLETELY: 'Video Viewed Completely',
  /**
   * Video Events
   */
  SCROLLED_TO_BOTTOM: 'Report Scrolled to Bottom',
  LOGIN_SIGNUP: 'Login Signup',
  INFERENCE_SECTION_VIEWED: 'Inference Section Viewed',
  GENERAL_ADVICE_SECTION_VIEWED: 'General Advice Section Viewed',
  RED_FLAGS_SECTION_VIEWED: 'Red Flags Section Viewed',
  BANNER_SECTION_VIEWED: 'Banner Section Viewed',
  CAROUSEL_SECTION_VIEWED: 'Carousel Section Viewed',
  CARETEAM_CAROUSEL_SECTION_VIEWED: 'CareTeam Carousel Section Viewed',
  VIDEO_SECTION_VIEWED: 'Video Section Viewed',
  DISCLAIMER_SECTION_VIEWED: 'Disclaimer Section Viewed',
  ADVICES_SECTION_VIEWED: 'GoodHealthSection',
  DIAGNOSIS_SECTION_VIEWED: 'Diagnosis Section Viewed',
  RECOMMENDATION_SECTION_VIEWED: 'Recommendation Section Viewed',
  PACKAGE_SECTION_VIEWED: 'Package Section Viewed',
  PRODUCT_FEATURES_SECTION_VIEWED: 'Product Features Section Viewed',
  JOURNEY_SECTION_VIEWED: 'Journey Section Viewed',
  CONSULT_SECTION_VIEWED: 'Consult Section Viewed',
  TESTIMONIALS_SECTION_VIEWED: 'Testimonials Section Viewed',
  SK_ADVICE_SECTION_VIEWED: 'Skincare Advice Section Viewed',
  SK_ROUTINE_SECTION_VIEWED: 'Skincare Routine Section Viewed',
  PRODUCT_KIT_VIEWED: 'Product Kit Viewed',
  SHARE_REPORT_SECTION_VIEWED: 'Share Report Section Viewed',
  TAB_SECTION_VIEWED: 'Tab Section Viewed',
  PDF_LANDING_PAGE_FROM_REPORTS_VIEWED: 'Pdf Landing Page Viewed',
  PDF_LANDING_PAGE: 'Pdf Landing Page',
};
export const BUTTON_NAME = {
  STORY_PLAY_BUTTON: 'Story Play Button',
  CLOSE_STORY_VIEW: 'Close Story View',
  CLOSE_LIST_VIEW: 'Close List View',
  NEXT_STORY_CARD: 'Next Story Card',
  PREV_STORY_CARD: 'Prev Story Card',
  DOWNLOAD_PDF: 'PdfDownload',
  DOWNLOAD_APP: 'Download APP',
  SHARE_ASSESSMENT: 'Share Assessment',
  SHARE_ASSESSMENT_TO_A_PLATFORM: 'SHARE_ASSESSMENT_TO_A_PLATFORM',
  CONSULT_DOCTOR: 'Consult Doctor',
  BANNER_PRESS: 'Banner Press',
  AYUSHMAN_CTA: 'BookNowAyushmanBtn',
  CONSULT_NOW_CTA: 'ConsultNowBtn',
  BOOK_FREE_CONSULTATION: 'Book Free Consultation',
  BOOK_VIDEO_CONSULTATION: 'Book Consultation',
  CLOSE_MODAL: 'Close Modal',
  CARE_PROGRAM_CTA: 'CareProgramJoinNowBtn',
  HORIZONTAL_SCROLL: 'HorizontalScroll',
  DISCLAIMER_READ_MORE: 'ReadMoreDisclaimerBtn',
  DISCLAIMER_LINK_TO_REF: 'LinkToReferencesDisclaimerBtn',
  ADVICES_BUTTON: 'AdvicesBtn',
  EXPERT_RECOM_BUTTON: 'ExpertRecoBtn',
  PRODUCT_VIEW_DETAILS: 'ProductViewDetailsBtn',
  DIAGNOSIS_VIEW_DETAILS: 'View More Details',
  PACKAGE_KNOW_MORE: 'Know More_Benefit',
  PRODUCT_KIT_KNOW_MORE: 'Know More_Kit',
  PRODUCT_BUY_NOW: 'ProductBuyNowBtn',
  OPEN_CHAT_BTN: 'OpenChatBtn',
  VIEW_PRESCRIPTION_CTA: 'ViewPrescriptionCta',
  ORDER_MEDICINE_BTN: 'OrderMedicineBtn',
  BOOK_LAB_TEST_BTN: 'BookLabTestBtn',
  GO_TO_REPORT_LIST_VIEW: 'Go To Report List View',
  PLAY_VIDEO: 'Play Video',
  PAUSE_VIDEO: 'Pause Video',
  FORWARD_VIDEO: 'Forward Video',
  BACKWARD_VIDEO: 'Backward Video',
  MUTE_VIDEO: 'Mute Video',
  UNMUTE_VIDEO: 'Unmute Video',
  SHOW_VIDEO_CONTROLS: 'Show Video Controls',
  HIDE_VIDEO_CONTROLS: 'Hide Video Controls',
  FOOTER_PRESS: 'Footer Press',
  REPORT_COMMUNICATION_MODE_SELECTION: 'Reports Communication Mode Selection',
  SEND_ASSESSMENT_REPORTS: 'Send Assessment Reports',
  CLOSE_SEND_REPORT_POPUP: 'Close Send Report Popup',
  CLOSE_SUCCESS_ON_GET_REPORT_POPUP: 'Close Success On Get Report Popup',
  CLOSE_ERROR_ON_GET_REPORT_POPUP: 'Close Error On Get Report popup',
  COACH_MARK_VIEWED: 'Coach Mark Viewed',
  COACH_MARK_CLOSED: 'Coach Mark Closed',
  LOGIN_SIGNUP_SUCCESS: 'Login Signup Success',
  CLOSE_LOGIN_SIGNUP: 'Close Login Signup',
  DOWNLOAD_PDF_FROM_TINY_URL_LANDING_PAGE: 'Download pdf from tiny url landing page',
  CST_POP_UP_CLOSED: 'CST Pop Up Closed',
  CST_SUBMISSION_SUCCESS: 'CST Submission Success',
  CSAT_CHAT_PILL: 'CSAT Chat Pill',
  TAB_CHANGE: 'Tab Change',
  VIDEO_PROGRESS_TAB_CHANGE: 'Video Progress Tab Change',
  LOCK_BUTTON: 'Lock Button',
  DAILY_REMINDER_TOGGLE: 'Daily Reminder Toggle',
};
export const POPUP_NAME = {
  SHOW_SHARE_ASSESSMENT_POP_UP: 'Show Share Assessment Pop Up',
  HIDE_SHARE_ASSESSMENT_POP_UP: 'Hide Share Assessment Pop Up',
  SEND_REPORTS_POPUP: 'Send Reports Pop Up',
  SUCCESS_ON_GET_REPORTS_POPUP: 'Success On Get Reports Pop Up',
  ERROR_ON_GET_REPORTS_POPUP: 'Error On Get Reports Pop Up',
  CST_POP_UP: 'Show CST Assessment Pop Up',
};
